import { useAppActions } from 'reducers/slices/loanOfficerDashboardSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadLoanOfficerDashboard } = useAppActions();
  const { loading, loanOfficerDashboard, meta } = useSelector(state => state.loanOfficerDashboardSlice);

  return {
    loadLoanOfficerDashboard,
    loanOfficerDashboard,
    loading,
    meta,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useLoanOfficerDashboard.js